import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'mp-foreground-cookies',
  styleUrl: 'mp-foreground-cookies.scss',
})
export class MpForegroundCookies {



  @Prop() index!: number;
  @Prop() collections!: any[];
  @Prop() sectionIndex: number;
  @Prop() level: number = 0;


  //private item: any = {};
  //private translations: any = {};



  async componentWillLoad() {

    //const data_manager = document.querySelector('mp-data-manager');

    //this.translations = await data_manager.getAllTranslations();

    //this.item = this.collections[this.index].item;

    //console.log(this.item);
  }

  componentDidLoad() {
  }


  render() {

    return (
      <Host>
        <hylo-page-width>
          <mp-top-logo index={Math.max(this.sectionIndex, this.index)} level={this.level}/>
          <mp-cookies/>
        </hylo-page-width>
      </Host>
    )
  }
}
